<script setup>
import HelpImage from "@/assets/help-image.jpg";
const { title, content } = defineProps(["title", "content"]);

const model = defineModel();

const emit = defineEmits(["confirm", "cancel"]);

const handleConfirm = () => {
  emit("confirm");
  model.value = false;
};

const handleCancel = () => {
  model.value = false;
  emit("cancel");
};

const handleHelp = () => {
  model.value = false;
  showImagePreview({
    images: [HelpImage],
    showIndex: false,
    className: "__help-img-preview",
    onClose: () => {
      model.value = true;
    },
  });
};

const handleToHome = () => {
  window.location.href = "https://banxueketang.com/";
};
</script>

<template>
  <van-overlay :show="model" @click="model = true" z-index="5000">
    <div class="wrapper">
      <div class="block" @click.stop>
        <div class="container">
          <div class="container-text">{{ title }}</div>

          <div class="container-info">
            由于网页版学习体验的局限性，我们仅在<span
              class="container-info-highlight"
              >伴学课堂</span
            >App内提供{{ content }}功能。
          </div>

          <!-- <div class="container-text-btns">
            <div class="container-text-btns-help" @click="handleHelp">
              使用帮助
            </div>
            <div class="container-text-btns-home" @click="handleToHome">
              官网下载
            </div>
          </div> -->

          <div class="container-btns">
            <div class="container-btns-cancel" @click="handleCancel">返回</div>
            <div class="container-btns-confirm" @click="handleConfirm">
              立即下载
            </div>
          </div>
        </div>
      </div>
    </div>
  </van-overlay>
</template>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.block {
  box-sizing: border-box;
  width: 319px;
  padding: 24px;
  background-color: #fff;
  border-radius: 24px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.container {
  width: 100%;
  .container-text {
    font-size: 20px;
    line-height: 28px;
    color: #000000d9;
    font-weight: 600;
    text-align: center;
  }
  .container-info {
    margin-top: 8px;
    font-size: 16px;
    line-height: 24px;
    color: #000000d9;
    font-weight: 400;
  }
  .container-info-highlight {
    margin: 0 4px;
    color: #ff8912ff;
    font-weight: 600;
  }
  .container-btns {
    display: flex;
    justify-content: space-between;
    margin-top: 64px;

    .container-btns-cancel,
    .container-btns-confirm {
      flex: 1;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 100px;
      font-size: 16px;
      color: #ffffff;
      cursor: pointer;
    }

    .container-btns-cancel {
      background-color: #f7f7f7;
      color: #000000d9;
    }

    .container-btns-confirm {
      margin-left: 8px;
      font-weight: 600;
      background: linear-gradient(90deg, #ffa431ff 0%, #ff8912ff 100%);
      position: relative;
    }
  }

  .container-text-btns {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00000059;
    font-size: 16px;
    line-height: 24px;
    text-decoration-line: underline;
    text-underline-offset: 2px;
    .container-text-btns-help {
      margin-right: 40px;
    }
    .container-text-btns-home {
    }
  }
}
</style>

<style lang="scss">
.__help-img-preview {
  z-index: 4000 !important;
}
</style>
